import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filter } from "./Filter";
import { Form } from "react-bootstrap";
export class FreeTextFilter extends Filter {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(filterProperty, name) {
        super(filterProperty, name);
    }
    render(_id, index, value) {
        return (_jsxs(Form.Group, { controlId: `freetext${index}`, style: { margin: 3, marginRight: 10, display: "inline-flex" }, children: [_jsx(Form.Label, { column: true, style: { paddingTop: 0, paddingBottom: 0, position: "relative", top: 4 }, children: this.name }), _jsx(Form.Control, { type: "text", value: value || "", size: "sm", onChange: (event) => this.onChange(this.filterProperty, event.currentTarget.value), style: { border: "none", height: 25, marginBottom: 0 } })] }, index));
    }
}
